import { FC } from "react";
import { useMediaQuery } from "react-responsive";
import { MAX_WIDTH_MOBILE } from "utils/constant";
import { ReactComponent as IconClose } from "../../assets/close.svg";
import Modal from "../Modal";
import styles from "./VideoPopup.module.scss";

interface VideoPopupProps {
  isOpen: boolean;
  videoUrl: string;
  onClose: () => void;
}

const VideoPopup: FC<VideoPopupProps> = ({ isOpen, videoUrl, onClose }) => {
  const isMobile = useMediaQuery({ maxWidth: MAX_WIDTH_MOBILE });
  if (!videoUrl) return null;

  const getVideoId = (url: string) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const videoId = getVideoId(videoUrl);
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={`${styles.videoPopup} ${isMobile ? styles.mobile : ""}`}>
        <button className={styles.closeButton} onClick={onClose}>
          <IconClose />
        </button>
        <div className={styles.videoContainer}>
          <iframe
            width="100%"
            height="100%"
            src={embedUrl}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </Modal>
  );
};

export default VideoPopup;
